import { apiServer } from "../config/config";
import { UserActivityReview } from "../types";
import User from "../types/user";
import { fetchWithToken } from "./fetchWithToken";

type UserActivityReviewResponse = {
  count: number;
  reviews: UserActivityReview[];
};

export async function getUserActivities(
  accessToken: string,
  offset: number,
  length: number
) {
  const response = await fetchWithToken(apiServer + "/user/sync-user-activities", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ offset, length }),
  });
  const result = await response?.json();
  return result.data as UserActivityReviewResponse;
}

export async function fetchPublicUser(id: string) {
  const response = await fetch(apiServer + `/user/public-user/${id}`);
  const data = await response.json();
  return data.data as User;
}

export async function fetchPublicUserActivities(
  id: string,
  offset: number,
  length: number,
  callingUserId: string
) {
  const response = await fetch(
    apiServer +
      `/user/public-activities/${id}/${offset}/${length}/${callingUserId}`
  );
  const data = await response.json();
  return data.data as UserActivityReviewResponse;
}

export async function deleteUserReview(reviewId: string, accessToken: string) {
  const formData = new FormData();
  formData.append("review_id", reviewId);
  const response = await fetchWithToken(`${apiServer + "/review/delete-review"}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  });
  return response?.json();
}


